import * as React from "react";
import MaterialSelect from "../../../components/MaterialSelect";
import BaseFilter from "../../../core/models/BaseFilter";
import MaterialDatePickerPair from "../MaterialDatePickerPair";
import { IconButton, makeStyles, createStyles, Theme, Tooltip } from "@material-ui/core";
import ReplayIcon from "@material-ui/icons/Replay";
import find from "lodash/find";
import addTime, { buildDateWindow, dateWindowBuildOptions } from "../../../helpers/datetime";
import uuidv4 from "../../../helpers/uuid";
import { IEnumerable } from "../../../core/models/ModelHelpers";
import { useHubEventDateWindow } from "../../../core/hooks/useHubHooks";
import { DateWindow } from "../../../core/models/DateWindow";
import { useHubx } from "../../../HubX";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customDateWrapper: {
      display: "flex",
      alignItems: "center",
    },
  })
);

const CUSTOM_OPTION_STR = "Personalizar";

type filterOptionsType = {
  key: number;
  value: string;
  option: dateWindowBuildOptions | undefined;
}[];

const filterOptions: filterOptionsType = [
  {
    key: 0,
    value: "Últimos dois dias",
    option: "2d",
  },
  {
    key: 1,
    value: "Última semana",
    option: "1w",
  },
  {
    key: 2,
    value: "Últimas duas semanas",
    option: "2w",
  },
  {
    key: 3,
    value: "Último mês",
    option: "1M",
  },
  {
    key: 4,
    value: "Últimos dois meses",
    option: "2M",
  },
  {
    key: 5,
    value: "Últimos três meses",
    option: "3M",
  },
  {
    key: 6,
    value: "Últimos seis meses",
    option: "6M",
  },
  {
    key: 7,
    value: CUSTOM_OPTION_STR,
    option: undefined,
  },
];

const CUSTOM_OPTION = find(filterOptions, ["value", CUSTOM_OPTION_STR])?.key || undefined;

type MaterialCustomSelectDateProps = {
  event?: IEnumerable;
  initialSelectionKey?: number;
};

function MaterialCustomSelectDate({
  event,
  initialSelectionKey = 1,
}: MaterialCustomSelectDateProps) {
  /* State type string only for empty selection */
  const [selection, setSelection] = React.useState<string | number>(initialSelectionKey);
  const [datewindow, setDateWindow] = React.useState<DateWindow | null>(null);

  const classes = useStyles();
  const hub = useHubx();

  const useId = React.useMemo(() => (event ? event : uuidv4()), [event]);
  const currentDateFromEvent = useHubEventDateWindow(useId);

  const isCustomSelect = React.useCallback(() => {
    return selection === CUSTOM_OPTION;
  }, [selection]);

  function handleChange(event: React.ChangeEvent<{ name?: string; value: number }>) {
    setSelection(event.target.value);
  }

  function handleClick() {
    setSelection("");
  }

  const filter: BaseFilter = {
    handleChange,
    items: filterOptions,
    id: "MaterialCustomSelectDate",
    label: "Data",
    value: selection,
  };

  React.useEffect(() => {
    if (typeof selection === "number") {
      const dateWindowOption = filterOptions[selection].option;
      if (dateWindowOption) {
        setDateWindow(buildDateWindow(dateWindowOption));
      } else {
        setDateWindow(currentDateFromEvent);
      }
    }
  }, [currentDateFromEvent, selection]);

  React.useEffect(() => {
    if (event) {
      hub.notify(event.toString(), datewindow);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, datewindow]);

  return (
    <>
      {!isCustomSelect() && <MaterialSelect filter={filter} />}
      {isCustomSelect() && (
        <div className={classes.customDateWrapper}>
          <MaterialDatePickerPair id={useId} startDate={addTime(new Date(), -1, "week")} />
          <Tooltip title={"Voltar para seleção de períodos pré-definidos"}>
            <IconButton onClick={handleClick}>
              <ReplayIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </>
  );
}

export default MaterialCustomSelectDate;
